import { delay } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientHeadersService } from '../../../services';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class BorrowingListService {

  constructor(private httpClient: HttpClient,
              private httpClientHeadersService: HttpClientHeadersService) {
  }

  getBorrowingList(params?: Object): Observable<any> {
    return this.httpClient.get(`${environment.API_ENDPOINT}borrowings`,
      {params: this.httpClientHeadersService.buildQueryParams(params)})
      .pipe(delay(environment.RESPONSE_DELAY));
  }

  getProfileBorrowingList(profileId: number) {
    return this.httpClient.get<any>(
      `${environment.API_ENDPOINT}borrowings/by-profile/${profileId}`);
  }
}
